import React, { useEffect, useState } from 'react';
import {ListingBanner, PropertyLisitingContext} from '../components/propertyLisiting';

import Navbar from '../components/navbar';
import { PropertryListDetailsBanner , KnowMoreIsc} from '../components/index';
import '../css/main.css';
import PropertyListBannerImage from '../Images/Plot.jpeg';
import userIcon from '../Images/user.png';
import axios from 'axios';
import {contactFormValidation} from '../components/validation';
import ContactFormAction from '../components/contactAction';
import { Link, Redirect, useHistory } from 'react-router-dom';
import PageBannerImage from '../Images/ISC-PropEx-BG-Image.jpg';
import TennisIcon from '../Images/tennis.svg';
import SwimmingPoolIcon from '../Images/swimming_pool.svg';
import PartyTerrace from '../Images/party_terrace.svg';
import Gym from '../Images/gym.svg';
import Cricket from '../Images/cricket.svg';
import ChildsPlay from '../Images/childs_play.svg';
import Billiards from '../Images/billiards.png';
import Banqueet from '../Images/banquet.svg';
import Badimation from '../Images/badminton.svg';
import AvRoom from '../Images/av_room.svg';
import LocationIcon from '../Images/location.svg';

const PropertyListDetails = (props) =>{
    const [propertyData,setPropertyData]=useState({propertyListData:[],matchParams:null,listPage:false,downloadPdfLink:'',pdfLinkDownloadedUrl:''});
    const [contactPerson,setContactPersonDetails]=useState({name:'',email:'',message:'',mobileNumber:'',successMessage:'',pdfLink:''})
    const data=props.match.params.id;
    var pdfLink='';
    
    const history=useHistory();
    const renderRedirect = () =>{
        if(data===''){
            <Redirect to='/property-list' />
        }
    }
    useEffect(()=>{
        renderRedirect();
        axios.get(`https://internationalstrategicconsultants.com/iscPropExApi/propertyList_details.php/?name=${data}`).then(res=>{
            setPropertyData({
                ...propertyData,
                propertyListData:res.data

            })
            
            
        
            
            
           
 }) 
    })
    const PdfLinkName = (pdfLinkUrl,e) =>{
        var pdfLinkPassedUrl=pdfLinkUrl;
        setContactPersonDetails({
            ...contactPerson,
            pdfLink:pdfLinkPassedUrl
        })
        setPropertyData({
            ...propertyData,
            pdfLinkDownloadedUrl:pdfLinkUrl
        })
        
        setContactPersonDetails({
            ...contactPerson,
            name:e.target.value
        })
        
    } 
    const ContactForm =  async e =>{
        e.preventDefault();
        
        
        const validationErrors=contactFormValidation(contactPerson);
        const noErrors = Object.keys(validationErrors).length === 0;
        if(noErrors){
            
               
             
            ContactFormAction(contactPerson).then((res) => {
                console.log(res);
                setPropertyData({
                    ...propertyData,
                    downloadPdfLink:`https://internationalstrategicconsultants.com/iscPropExApi/propertyDownloding.php/?id=${propertyData.pdfLinkDownloadedUrl}`
    
                })
                
                if(res.data.success===1){
                    
                    
                    setContactPersonDetails({
                        ...contactPerson,
                        successMessage:res.data.message
                      }) 
                      alert(res.data.message)
                      
                      window.location.reload(true);
                      
                 
                 
                }
                else{
                    setContactPersonDetails({
                    ...contactPerson,
                    successMessage:res.data.errorMessage
                  })
                } 
            })
            .catch(err=>{

            }) 

           
       
            
        }
        else{
            alert('Please Fill up The Form');
        }
        
    }
    
        

    
      
   return(
        <>
        <Navbar />
        {
            propertyData.propertyListData.map((result) => {
               var pdfLink=result.pdfUploaded;
               console.log(result);
                var propertyImages=result.PropertyImages.split(',');
                console.log(result.video);
                let video=result.video;
                let name=result.Name;
                let animiety=result.animets;
               return(
                <>
                <section className="propertyListBanner jumbotron" style={{backgroundImage:`url(${PageBannerImage})`,backgroundSize:"cover"}}>
                    <div className="container">
                        <div className="row justify-center">
                            <div className="col-md-3 col-lg-3">
                                 <img src={result.Logo} style={{width:"100%"}}/>
                            </div>
                            { /* <div className="col-md-1 col-lg-1">

                            </div>
                            <div className="col-md-5 col-lg-5 align-center">
                                <h4 className="property-list-details-title" style={{textAlign:"inherit"}}>{result.Name}</h4>
                            </div> */
               }
                        </div>
                    </div>
                </section>
            <section className="video-section">
                    <div className="container">
                        
                        {
                            video ?
                            <iframe width="100%" height="450" src={result.video} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        :
                           <video controls>
                           <source src={`${process.env.PUBLIC_URL}/WakerBurn.mp4`} type="video/mp4" />
                           <source src="movie.ogg" type="video/ogg" />
   
                           </video>
                        }
                         
                       
            
                    </div>
                </section>
                <div className="container">
                    <div className="row" style={{marginTop:"0px"}}>
                        <div className="col-md-12 col-lg-12">
                            <div className="row">
                                <div className="col-md-6 col-lg-6">
                                    <h4 className="PlotList-Villa-Title list-details-title">{result.Name}</h4>
                                            <h4 className="Plot-Product-title">{result.propertyType}</h4>
                                            { result.location ?
                                            <h4 className="Plot-Product-title">Location: {result.location}</h4>
                                            : null
                                            }
                                            { result.subLocation ?
                                            <h4 className="Plot-Product-title">Sub Location: {result.subLocation}</h4>
                                            : null
                                            }
                                            
                                        </div>
                                        { /*<div className="col-md-3 col-lg-3">
                                            <h4 className="PlotList-Villa-Sqyards" style={{color:"#1d1d1d",marginTop:"0px"}}>{result.squareYardsData}<br/>
                                            <span>{result.squareYard}</span><br/>
                                            <span></span></h4>
                                        </div>
                                        <div className="col-md-3 col-lg-3">
                                              <h4 className="PlotList-Villa-Sqyards" style={{color:"#1d1d1d",marginTop:"0px"}}>Price {result.squareYardsData}<br/>
                                            <span>{result.PriceSquareFeet}</span></h4>
                    </div> 
                                    </div>
                                    
                                </div> */}
                                <div className="col-md-6 col-lg-6 align-center text-align-end">
                                    <span className="PlotList-Villa-Title list-details-title">{result.total ? <span>Rs {result.total}</span> : null}</span>
                                    <h4 className="Plot-Product-title">{ result.squareYard ? <span>{result.squareYardsData} <strong>{result.squareYard}</strong><span class="mobile-display"><br/></span>{ result.squareYard && result.PriceSquareFeet ? <span className="mobile-hide">|</span>: null }</span> : result.PriceSquareFeet ? <span> Price {result.squareYardsData} <strong>{result.PriceSquareFeet}</strong></span> : null}</h4>
                                    
                                </div>
                            </div>
                           
                        </div>
        
                        
                    </div>
                    {
                        result.propertyType==='Residential'?
                        <>
                        <section className="plot-Details-space">
                            {
                                result.PriceSquareFeet ?
                              <div className="row plot-seperate-space">
                               <div className="col-8 no-padding-space">
                                  <h4 className="propertyAreaSqaure"><span className="checkMark">&#10004;</span><span className="plot-data-title">Total area of land in sq. feet</span></h4>
                                </div>
                                <div className="col-4 text-align-end-plot no-padding-space">
                                    <h4 className="propertyCost">{result.PriceSquareFeet}</h4>
                                </div>

                            </div>
                            :null
                            }
                           {
                               result.areaBuilt ?
                           <div className="row plot-seperate-space">
                               <div className="col-8 no-padding-space">
                                  <h4 className="propertyAreaSqaure"><span className="checkMark">&#10004;</span><span className="plot-data-title">Built up area of land in sq. feet</span></h4>
                                </div>
                                <div className="col-4 text-align-end-plot no-padding-space">
                                    <h4 className="propertyCost">{result.areaBuilt}</h4>
                                </div>

                            </div>:null
                            }
                            {
                                result.houseVillaNumber?
                                <div className="row plot-seperate-space">
                                <div className="col-8 no-padding-space">
                                    <h4 className="propertyAreaSqaure"><span className="checkMark">&#10004;</span><span className="plot-data-title">House or Villa Number</span></h4>
                                    </div>
                                    <div className="col-4 text-align-end-plot no-padding-space">
                                        <h4 className="propertyCost">{result.houseVillaNumber} Villas</h4>
                                    </div>

                                </div>
                                : null
                            }
                            {
                                result.bedRoomsCount ?
                                <div className="row plot-seperate-space">
                                <div className="col-8 no-padding-space">
                                    <h4 className="propertyAreaSqaure"><span className="checkMark">&#10004;</span><span className="plot-data-title">No. of Bedrooms</span></h4>
                                    </div>
                                    <div className="col-4 text-align-end-plot no-padding-space">
                                        <h4 className="propertyCost">{result.bedRoomsCount} bedrooms</h4>
                                    </div>

                                </div>
                            : null

                            }
                            {
                                result.toiletsCount ?
                                <div className="row plot-seperate-space">
                                <div className="col-8 no-padding-space">
                                    <h4 className="propertyAreaSqaure"><span className="checkMark">&#10004;</span><span className="plot-data-title">No. of Toilets</span></h4>
                                    </div>
                                    <div className="col-4 text-align-end-plot no-padding-space">
                                        <h4 className="propertyCost">{result.toiletsCount} toilets</h4>
                                    </div>

                                </div>
                            : null

                            }
                            {
                                result.parkingCount ?
                                <div className="row plot-seperate-space">
                                    <div className="col-8 no-padding-space">
                                    <h4 className="propertyAreaSqaure"><span className="checkMark">&#10004;</span><span className="plot-data-title">No. of Parking slots</span></h4>
                                    </div>
                                    <div className="col-4 text-align-end-plot no-padding-space">
                                        <h4 className="propertyCost">{result.parkingCount} slots</h4>
                                    </div>
    
                                </div>
                             : null

                            }
                            {
                                result.sump ?
                                <div className="row plot-seperate-space">
                                <div className="col-8 no-padding-space">
                                    <h4 className="propertyAreaSqaure"><span className="checkMark">&#10004;</span><span className="plot-data-title">Capacity of Sump Water Facilty</span></h4>
                                    </div>
                                    <div className="col-4 text-align-end-plot no-padding-space">
                                        <h4 className="propertyCost">{result.sump} lts</h4>
                                    </div>

                                </div>
                                : null

                            }
                            {
                               result.waterFacilitiesCapacity ?
                               <div className="row plot-seperate-space">
                                <div className="col-8 no-padding-space">
                                    <h4 className="propertyAreaSqaure"><span className="checkMark">&#10004;</span><span className="plot-data-title">Capacity of Over Head Tank Water Facilty</span></h4>
                                    </div>
                                    <div className="col-4 text-align-end-plot no-padding-space">
                                        <h4 className="propertyCost">{result.waterFacilitiesCapacity} lts</h4>
                                    </div>

                                </div>
                                : null

                            }
                            
                           {
                               result.others ?
                               <div className="row plot-seperate-space">
                                <div className="col-8 no-padding-space">
                                    <h4 className="propertyAreaSqaure"><span className="checkMark">&#10004;</span><span className="plot-data-title">Others</span></h4>
                                    </div>
                                    <div className="col-4 text-align-end-plot no-padding-space">
                                        <h4 className="propertyCost">{result.others}</h4>
                                    </div>

                                </div>
                                : null

                           }
                            
                            
                            
                            
                          </section>
                        </>
                        : null
                    }
                    
                </div>

                <div className="carousel slide PropertyListSliding propertyDetails" id={"carouselExampleControls"+result.id} data-ride="carousel" style={{marginBottom:"30px",marginTop:"50px"}}>
           
                <div className="container">
                    <div className="carousel-inner">
                        {
                           propertyImages.map((Images,index) =>{
                            let active='';
                            if(index===0){
                                active='active'
                            }
                            return(
                                Images ?
                                <div className={"carousel-item "+active} id={index} data-bs-interval="10000">
                                    <div className="row">    
                                        <div className="col-md-12 col-lg-12">
                                            <img src={'https://internationalstrategicconsultants.com/iscPropExApi/uploads/'+Images} alt="PropertyImage" className="d-block w-100"  />
                                        </div>
                                    </div>
                                </div>
                                : null
                            )
                           })
                        }
                        <a className="carousel-control-prev" href={"#carouselExampleControls"+result.id} role="button" data-slide="prev">
                            <i class="fa fa-angle-left" aria-hidden="true"></i>
                            <span className="sr-only">Previous</span>
                            </a>
                            <a className="carousel-control-next" href={"#carouselExampleControls"+result.id} role="button" data-slide="next">
                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                            <span className="sr-only">Next</span>
                            </a>
                    </div>
                        
                </div>
                    
            </div>
            <div className="container">
                
                <div className="row" style={{marginTop:"40px",marginBottom:"50px"}}>
                    <div className="col-md-12 col-lg-12">
                    <h4 className="property-title" style={{color:"#22238d",textAlign:"left"}}>About the project </h4>
                        {
                            name==='BrigadeResidences' ?
                            <p class="product-list-description">Presenting Brigade Residences at World Trade Center. Ultra-luxury homes that are exclusive in the truest sense. Part of the same integrated development as the World Trade Center. Chennai..<br/><br/>
                            And by virtue of which. not replicable, ever again, in the city.<br/><br/>
                            Located in the IT Hub on OMR, at Perungudi, Brigade Residences at World Trade Center is a part of a complete ecosystem, with luxury homes, top-of-the-line commercial and office spaces at the WTC towers. executive apartments·. and retail space.<br/><br/>
                            These ultra-premium homes with 3 sides open. offer a stunning unhindered view of either the sea. the cityscape or of Perungud1 Lake. At an unbeatable starting price of f2 Cr+-+.<br/><br/>
                            Not surprisingly for the development of such 1mpcccablc lineage, Brigade Residences 1s replete with all manner of lifestyle and wellness features of international standards.
                            <br/><br/>But like all good things, there are only a few of these luxury homes going around. Then again. 11 wouldn't be exclusive if 11 was for everyone!</p>
                            :
                            <p class="product-list-description">{result.aboutProperty}</p>
                        }
                        
                    </div>
                </div>
            </div>
                {
                 name==='BrigadeResidences' ?
                 <>
            <div className="container">
                <h4 className="property-title" style={{color:"#22238d", textAlign:"left"}}>Location Highlights</h4>
                    <div className="row" style={{marginBottom:"40px",marginTop:"30px",justifyContent:"center"}}>
                        <div className="col-md-4 col-lg-4 no-desktop-padding">
                            <div class="locations-icon-text">
                            <img class="wp-post-image" src={LocationIcon} alt="Post 1" />
                            <p>VHS Hospital 1.20 KM</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 no-desktop-padding">
                            <div class="locations-icon-text">
                            <img class="wp-post-image" src={LocationIcon} alt="Post 1" />
                            <p>government High School 1.42 KM</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 no-desktop-padding">
                            <div class="locations-icon-text">
                            <img class="wp-post-image" src={LocationIcon} alt="Post 1" />
                            <p>Located right at the central hub of the IT corridor</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 no-desktop-padding">
                            <div class="locations-icon-text">
                            <img class="wp-post-image" src={LocationIcon} alt="Post 1" />
                            <p> At the start of OMR, right before Perungudi Toll Plaza</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 no-desktop-padding">
                            <div class="locations-icon-text">
                            <img class="wp-post-image" src={LocationIcon} alt="Post 1" />
                            <p>Just 30 minutes from the Chennai International Airport</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 no-desktop-padding">
                            <div class="locations-icon-text">
                            <img class="wp-post-image" src={LocationIcon} alt="Post 1" />
                            <p>Easy access to the best business and recreation hubs of Chennai</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 no-desktop-padding">
                            <div class="locations-icon-text">
                            <img class="wp-post-image" src={LocationIcon} alt="Post 1" />
                            <p>Exceptional connectivity to offices, schools, colleges and conveniences</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 no-desktop-padding">
                            <div class="locations-icon-text">
                            <img class="wp-post-image" src={LocationIcon} alt="Post 1" />
                            <p>Easy access to the upcoming metro line</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 no-desktop-padding">
                            <div class="locations-icon-text">
                            <img class="wp-post-image" src={LocationIcon} alt="Post 1" />
                            <p> 5 minutes walk from multi-speciality hospital</p>
                            </div>
                        </div>
                        
                        
                    </div>
                    
            </div>
            </>
            : null
                }
            {
                animiety==="yes" ?
                <>
            <section className="animets">
                <div className="container">
                <h4 className="property-title" style={{color:"#22238d"}}>Amenities</h4>
                    <div className="row" style={{marginTop:"40px",justifyContent:"center"}}>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={TennisIcon} alt="Post 1" />
                               <p>Tennis Court</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={PartyTerrace} alt="Post 1" />
                               <p>Party Terrace</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={Cricket} alt="Post 1" />
                               <p>Cricket Practice Pitch</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={AvRoom} alt="Post 1" />
                               <p>AV Room</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={Banqueet} alt="Post 1" />
                               <p>Banquet Hall</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={Gym} alt="Post 1" />
                               <p>Gym</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={ChildsPlay} alt="Post 1" />
                               <p>Childrens Play Area</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={Badimation} alt="Post 1" />
                               <p>Badminton Court</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={Billiards} alt="Post 1" />
                               <p>Billiards</p>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3">
                            <div class="animets-icon">
                               <img class="wp-post-image" src={SwimmingPoolIcon} alt="Post 1" />
                               <p>Swimming Pool with Kid's Pool and Jacuzzi</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>
            </>
            :null
            }
            <div className="container" style={{marginTop:"20px"}}>
                <div className="row justify-center" style={{marginTop:"40px",marginBottom:"50px"}}>
                     <a href="#download-documents" className="btn btn-lg btn-message-submit" style={{color:"#fff"}}>Download Brochure</a>
                </div>
                
                <div className="row" style={{marginTop:"40px",marginBottom:"50px"}}>
                    <div className="col-md-12 col-lg-12">
                    <h4 className="property-title" style={{color:"#22238d",textAlign:"left"}}>Location</h4>
                        <iframe src={result.googleMap} style={{width:"100%",height:"500px"}} />
                    </div>
                </div>
            </div>
            <section className="Plot-List-Details-Values spacing-for-footer">
            <div className="container">
                <h4 className="property-title" style={{color:"#22238d",textAlign:"left"}}>Contact Agent</h4>
                <div className="row" style={{marginTop:"40px"}} id="download-documents">
                    <div className="col-md-4 col-lg-4 user-Profile-Details">
                        <div className="profile-contact">
                            <img src={userIcon} />
                            <h4 className="user-Name">Padmanabhan</h4>
                        </div>
                        <div className="userProfile-content" style={{marginTop:"30px"}}>
                            <p>Successful channel partner in the states of Tamilnadu, Karnataka and Kerala for over 20 years</p>
                        </div>
                    </div>
                    <div className="col-md-8 col-lg-8 no-padding message-contact">
                        <div className="Contact-person-contactDetails row">
                            <div className="col-md-5 col-lg-5">
                                 <p><a href="https://api.whatsapp.com/send?phone=919943809000&text=Hi!%20I%27m%20interested%20in%20the%20Brigade%20Residences%20WTC%20Chennai%20project!%20Please%20share%20more%20details%2C%20thanks!"><i class="fa fa-whatsapp"></i> +91 994 380 9000</a></p>
                            
                            </div>
                            <div className="col-md-7 col-lg-7">
                            <p className="last-align"><i class="fa fa-envelope-o"></i> <a href="mailto:iscpadmanabhan@gmail.com" style={{textDecoration:"none"}} title="mail">iscpadmanabhan@gmail.com</a></p>
                            
                            </div>
                            
                        </div>
                        <div className="send-instant-Message">
                            <h4 className="instance-Message-title">Send Message</h4>
                            <form onSubmit={ContactForm}>

                                <div className="form-row">
                                    <div className="col">
                                    <input type="text" className="form-control" placeholder="Name" onChange={e=>PdfLinkName(result.id,e)} value={contactPerson.name} />
                                    </div>
                                   <iframe src={propertyData.downloadPdfLink} style={{display:"none"}}/>
                                </div>
                                <div className="form-row">
                                    <div className="col">
                                    <input type="email" className="form-control" placeholder="Email"  onChange={e=>setContactPersonDetails({...contactPerson,email:e.target.value})} value={contactPerson.email} />
                                    </div>
                                    <div className="col">
                                        <input type="number" className="form-control" placeholder="Enter Mobile Number" onChange={e=>setContactPersonDetails({...contactPerson,mobileNumber:e.target.value})} value={contactPerson.mobileNumber} />
                                       
                                    </div>
                                </div>
                                
                                <div className="form-row">
                                    <div className="col">
                                        <textarea name="Message" placeholder="Message" className="form-control" onChange={e=>setContactPersonDetails({...contactPerson,message:e.target.value})} value={contactPerson.message} ></textarea>
                                    </div>
                                    
                                </div>
                                <div className="submit-button">
                                    <button type="submit" className="btn btn-lg btn-message-submit">Send Message</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <KnowMoreIsc />
            </>
               )
            })
        }
        
        
        
        </>
    )
    }
export default PropertyListDetails;
